<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 hourly-sales" id="hourly-sales">
    <po-widget>
      <span class="po-font-text-bold title">Condicionais pendentes</span>
      <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" *ngIf="!loading && !errorApi" (click)="downloadExcel()"></span>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div *ngIf="!loading && errorApi">
        <app-error [message]="message"></app-error>
      </div>
      <div class="po-table-main-container" *ngIf="!loading && !errorApi">
        <div class="po-table-wrapper" style="opacity: 1">
          <div style="height: 290px; overflow-y: auto; min-width: 500px;">
            <table class="po-table">
              <thead>
                <tr class="po-table-header">
                  <th class="po-table-header-ellipsis" (click)="ordenarTabela('cliente')">
                    <div class="po-table-header-flex">
                      <span class="po-table-header-ellipsis"> Cliente </span>
                      <span id="icon-cliente-condition-pending" class="po-icon po-icon-arrow-down"></span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis" (click)="ordenarTabela('qtd')">
                    <div class="po-table-header-flex">
                      <span class="po-table-header-ellipsis"> Quantidade </span>
                      <span id="icon-qtd-condition-pending" class="po-icon po-icon-arrow-down"></span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis" (click)="ordenarTabela('qtd-dias')">
                    <div class="value-column">
                      <span class="po-table-header-ellipsis"> Qtd. dias </span>
                      <span id="icon-qtd-dias-condition-pending" class="po-icon po-icon-arrow-down"></span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis" (click)="ordenarTabela('valor')">
                    <div class="value-column">
                      <span class="po-table-header-ellipsis"> Valor R$ </span>
                      <span id="icon-valor-condition-pending" class="po-icon po-icon-arrow-down"></span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis">
                    <div class="po-table-header-flex">
                      <span class="po-table-header-ellipsis"> Ação </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="po-table-group-row" *ngFor="let item of tableItens">
                <tr class="po-table-row">
                  <td class="po-table-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>{{item.cliente}}</span>
                    </div>
                  </td>
                  <td class="po-table-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>{{item.quantidade}}</span>
                    </div>
                  </td>
                  <td class="po-table-column value-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>{{item.qtdDias}}</span>
                    </div>
                  </td>
                  <td class="po-table-column value-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>{{item.valor}}</span>
                    </div>
                  </td>
                  <td class="po-table-column value-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate" style="font-size: 20px; display: flex;">
                      <span id="chartIcon" class="po-icon po-icon-chart-columns po-m-1 po-ml-0 pointer-cursor" p-tooltip="Estatísticas do cliente" (click)="openChart(item)"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center po-pt-2 more-details po-clickable"
              (click)="goToPeddingConditionals()">
              <span>+ Detalhes</span>
            </div>
        </div>
      </div>
    </po-widget>
    <app-modal-person-statistics #modalStats [personSelect]="personSelect"
      [personStatisticsInfo]="personStatisticsInfo" [limitPersonInfo]="limitPersonInfo" 
      [openInvoiceValue]="openInvoiceValue" [branchCodes]="branchCodes"></app-modal-person-statistics>
  </div>